import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";

const RuleTableBody = ({ tableData = [], loading = false, columnSearch = {}, renderHighlightedText = (t) => t, truncateText = (t, n) => t, truncateTexts = (t, n) => t }) => {
  return (
    <tbody>
      {loading ? (
        [...Array(5)].map((_, i) => (
          <tr key={i}>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={130} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={130} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={110} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={120} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={130} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={130} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={130} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="text" width={110} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="rectangular" width={140} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="rectangular" width={120} height={20} /></td>
            <td className="px-[25px] py-2"><Skeleton variant="rectangular" width={120} height={20} /></td>

          </tr>
        ))
      ) : tableData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center py-10 text-gray-500">No Data Available</td>
        </tr>
      ) : (
        tableData.map((row, index) => (
          <tr key={index} className={`transition-colors cursor-pointer ${index % 2 === 0 ? "bg-white" : "#eee"} hover:!bg-[#E4F8F1]`}>
            <td className="px-4 py-2 truncate text-[10px]  text-[#404040]">
              <div className="w-[130px] text-[10px]  text-[#404040]">
                {row.data_product_name ? renderHighlightedText(truncateText(row.data_product_name, 30), columnSearch.data_product_name) : "null"}
              </div>
            </td>

            <td className="px-4 py-2">
              <Tooltip title={row.data_asset_name ? (row.data_asset_name.includes("|") ? row.data_asset_name.split("|")[1] : row.data_asset_name) : "-"} slotProps={{ tooltip: { sx: { backgroundColor: "#ece5e5ff", color: "black", fontSize: "10px", fontFamily: "Poppins", padding: "8px 10px", borderRadius: "6px", maxWidth: "400px", whiteSpace: "pre-wrap" } } }}>
                <span className="block w-[130px] text-[10px]  text-[#404040] truncate">
                  {row.data_asset_name ? renderHighlightedText(truncateText(row.data_asset_name.includes("|") ? row.data_asset_name.split("|")[1] : row.data_asset_name, 30), columnSearch.data_asset_name) : "null"}
                </span>
              </Tooltip>
            </td>

            <td className="px-4 text-[10px]  text-[#404040] py-2">
              <Tooltip title={row.rule_name ? (row.rule_name.includes("|") ? row.rule_name.split("|")[1] : row.rule_name) : "-"} slotProps={{ tooltip: { sx: { backgroundColor: "#ece5e5ff", color: "black", fontSize: "10px", fontFamily: "Poppins", padding: "8px 10px", borderRadius: "6px", maxWidth: "400px", whiteSpace: "pre-wrap" } } }}>
                <span className="block text-[10px]  text-[#404040]">
                  {row.rule_name ? renderHighlightedText(truncateText(row.rule_name.includes("|") ? row.rule_name.split("|")[1] : row.rule_name), columnSearch.rule_name) : "null"}
                </span>
              </Tooltip>
            </td>

            <td className="px-4 text-[10px]  text-[#404040] py-2">
              <Tooltip title={row.rule_description || "-"} slotProps={{ tooltip: { sx: { backgroundColor: "#ece5e5ff", color: "black", fontSize: "10px", fontFamily: "Poppins", padding: "8px 10px", borderRadius: "6px", maxWidth: "400px", whiteSpace: "pre-wrap" } } }}>
                <span className="block text-[10px]  text-[#404040] w-[120px]">
                  {row.rule_description ? renderHighlightedText(truncateTexts(row.rule_description), columnSearch.rule_description) : "null"}
                </span>
              </Tooltip>
            </td>

            <td className="px-4  text-[10px]  text-[#404040] py-2">
              <div className="w-[130px">{row.check_name ? renderHighlightedText(truncateText(row.check_name), columnSearch.check_name) : "null"}</div>
            </td>

            <td className="px-4 py-2 text-[10px]  text-[#404040] capitalize">
              <div className="w-[130px] text-[10px]  text-[#404040] truncate">{row.dimension_name ? renderHighlightedText(row.dimension_name, columnSearch.dimension_name) : "null"}</div>
            </td>

            <td className="px-4 text-[10px]  text-[#404040] py-2">
              <div className="w-[100px] text-[10px]  text-[#404040]">{row.total_row_count ? renderHighlightedText(row.total_row_count.toString(), columnSearch.total_row_count) : "NA"}</div>
            </td>

            <td className="px-4 text-[10px]  text-[#404040] py-2">
              <div className="w-[100px] text-[10px]  text-[#404040]">{row.error_record_count !== null && row.error_record_count !== undefined ? renderHighlightedText(String(row.error_record_count), columnSearch.error_record_count) : "NA"}</div>
            </td>

            <td className="px-4 py-2 text-[10px]  text-[#404040]">
              <div className="w-[130px] text-[10px]  text-[#404040] truncate flex flex-col">
                <span style={{ color: "black" }}>{row.quality_score !== null && row.quality_score !== undefined ? renderHighlightedText(String(row.quality_score), columnSearch.quality_score) : "-"}</span>

                <div className="w-full bg-gray-200  rounded-full h-[8px] mt-1 relative overflow-hidden">
                  <div className="h-[8px] rounded-full transition-all duration-300 absolute top-0 left-0" style={{ width: `${parseFloat(row.quality_score) || 0}%`, backgroundColor: row.quality_score >= 95 ? "#009F52" : row.quality_score >= 90 ? "#FFC100" : "#FB0301" }} />
                </div>
              </div>
            </td>

            <td className="px-4 py-2 text-[10px]  text-[#404040]">
              <div className="w-[120px] truncate text-[10px]  text-[#404040]">
                {row.execution_date ? renderHighlightedText(new Date(row.execution_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }), columnSearch.execution_date) : "-"}
              </div>
            </td>
            <td className="px-4 py-2 text-[10px]  text-[#404040] capitalize">
              <div className={`w-[130px] text-[10px] truncate ${
              row?.status === "pass"
                ? "text-green-700"
                : row?.status === "fail"
                ? "text-red-700"
                : "text-[#404040]"
            }`}>{row.status ? renderHighlightedText(row.status, columnSearch.status) : "null"}</div>
            </td>
          </tr>
        ))
      )}
    </tbody>
  );
};

export default RuleTableBody;
